import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import {
    getSocialIdentityProviderDataFromServer,
    addSocialIdentityProviderDataToServer,
    updateSocialIdentityProviderDataToServer,
    deleteSocialIdentityProviderDataFromServer,
} from "./msgs/socialIdentityProviderAPICallers";
import {
    UpdateSocialIdentityProvider,
    DeleteSocialIdentityProvider,
    SocialIdentityProviders,
    AddSocialIdentityProvider,
} from "userful-chronos-app-common-js/dist/models/usermgt/socialIdentityProviders";

export interface InitialStateSocialIdentityProvider {
    socialProviders: SocialIdentityProviders;
    loadBool: boolean;
    saveBool: boolean;
    overlay: boolean;
}

const initialStateSocial: InitialStateSocialIdentityProvider = {
    socialProviders: { providers: [] },
    loadBool: true,
    saveBool: false,
    overlay: false,
};

export const socialIdentityProviderSlice = createSlice({
    name: "socialIdentityProviderSlice",
    initialState: initialStateSocial,
    reducers: {
        getSocialIdentityProviderFromServer: (state, action: PayloadAction<{}>) => {
            getSocialIdentityProviderDataFromServer(getGlobalStates().keycloak.token);
        },
        setSocialIdentityProvider: (state, action: PayloadAction<SocialIdentityProviders>) => {
            state.socialProviders = action.payload;
        },
        setLoadBool: (state, action: PayloadAction<boolean>) => {
            state.loadBool = action.payload;
        },
        addSocialIdentityProviderToServer: (state, action: PayloadAction<AddSocialIdentityProvider>) => {
            addSocialIdentityProviderDataToServer(getGlobalStates().keycloak.token, action.payload);
        },
        updateSocialIdentityProviderToServer: (state, action: PayloadAction<UpdateSocialIdentityProvider>) => {
            updateSocialIdentityProviderDataToServer(getGlobalStates().keycloak.token, action.payload);
        },
        deleteSocialIdentityProviderFromServer: (state, action: PayloadAction<DeleteSocialIdentityProvider>) => {
            deleteSocialIdentityProviderDataFromServer(getGlobalStates().keycloak.token, action.payload);
        },
        setSaveBool: (state, action: PayloadAction<boolean>) => {
            state.saveBool = action.payload;
        },
        setOverlay: (state, action: PayloadAction<boolean>) => {
            state.overlay = action.payload;
        },
    },
});

export const socialIdentityProviderSliceActions = socialIdentityProviderSlice.actions;

export default socialIdentityProviderSlice.reducer;
